import React from 'react'
import Select from 'react-select'

const options = ['kpi', 'lockCreator', 'rental', 'dataanalytics', 'exploring', 'qtools', 'vendor-onboarding-modal', 'storageCreator'].map((o) => ({ label: o, value: o }))

const Roles = ({ admin, mutateAdmin }) => (
  <div>
    <Select noOptionsMessage={() => 'Tomt'} isMulti isClearable onChange={(list) => mutateAdmin({ ...admin, roles: (list || []).map((r) => r.value) })} value={admin.roles.map((r) => ({ label: r, value: r }))} options={options} placeholder="Roller" />
  </div>
)

export default Roles
